import api from './axios'

export default {
  distributeBonus: (data, config) =>
    api.post('/group/member_bonus', data, config),
  reclaimBonus: (params, config = {}) =>
    api.delete('/group/member_bonus', { params, ...config }),
  getGroupInfoByInvitation: (params, config = {}) =>
    api.get('/invite/group', { params, ...config }),

  applyGroupBonus: (data, config) => api.post('/group/request', data, config),
  getApplyHistory: (params, config = {}) =>
    api.get('/group/request_history', { params, ...config }),
  getGroupApply: (params, config = {}) =>
    api.get('/group/request', { params, ...config }),

  getImages: (params, config = {}) =>
    api.get('/group/images', { params, ...config }),
  setImages: (data, config) => api.put('/group/images', data, config)
}
